import React from "react";
import AddToCartToSeePrice from "./AddToCartToSeePrice";
import { VariantProps } from ".";

const S = ({
  mapPrice,
  user,
  selectedProduct,
  productListingView,
}: VariantProps) => {
  const props = {
    unitOfMeasure: selectedProduct.unitOfMeasure,
    price: selectedProduct.price,
    user,
    mapPrice,
    type: selectedProduct.price.minimumAdvertisedPriceProperties.type,
    showLoginLink:
      selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    priceCrossedOut: true,
    showDiscount: true,
    productListingView,
  };

  return <AddToCartToSeePrice {...props} />;
};

export default S;
